<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <pre
    :class="props.class"
    class="overflow-x-auto"
  ><slot /></pre>
</template>

<style>
pre code .line {
  display: block;
}
</style>
